// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__cL5HI","clinicsSelect":"TableHeading_clinicsSelect__2xbJ5"};